import Vue from 'vue'
import ParserDate from '@/shared/date/parser-date'

export function initFilters() {
  Vue.filter('formatDate', (value) => {
    if (value) {
      return ParserDate.getFormattedDateFromDate(value)
    }
    return ''
  })
}
